import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const RespiteServices = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Respite Services
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex'>
              <p className='text-black sm:text-justify md:text-xl'>
                Respite services are immensely valuable to give families with
                special needs children regular caregiving breaks. Our respite
                workers offer both in home and in community respite service to
                accompany your child as they play and socialize with others and
                can also play the role of caregiver to accompany your child to
                community programs like swimming, skating, reading at the
                library, playing at the park and much more. Both FSCD vendor
                direct pay and private pay options are available.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/respite.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RespiteServices;
